import React from 'react';
import { FirstMenu } from '../../../models/first-menu.entity';
import i18n from '../../../i18n';
import GlobalNotification from '../../../component/common/snackbar';
import { apiManage_rbp } from '../../../request';
import Card from '../Card';
import { Box, Button, Grid, Skeleton, Typography } from '@mui/material';
import _ from 'lodash';
import ButtonComponent from '../../../component/button/button.component';


class ExtraCostFirstMenuSetting extends React.PureComponent<Props, State> {
    public state: State = {
        // 菜单列表
        menus: [],
        // 选中的菜单id
        selectedId: undefined,
        // setting 的id
        oldSelectedId: undefined,
        // 加载中
        isLoading: false,
    }

    // *********************
    // Life Cycle Function
    // *********************
    async componentDidMount() {
        await this.init()
    }

    // *********************
    // Default Function
    // *********************
    async init() {
        // setLinearLoading(true)
        this.setState({ isLoading: true })
        const getMenu = apiManage_rbp.get_menus_v3({ with_dish: false })
        const getSelected = apiManage_rbp.getSettingById(1)
        await Promise.all([getMenu, getSelected]).then(results => {
            let menus = _.cloneDeep(this.state.menus)
            let selectedId;
            !_.get(results[0], 'error') ? menus = results[0] :
                _.get(results[0], 'message') === 'canceled' || GlobalNotification.error(i18n.t('kwa_setting_page_get_first_level_menu_failed'))
            !_.get(results[1], 'error') && (selectedId = _.get(results[1], '[0].value.menu_id', undefined));
            this.setState({ menus, selectedId, oldSelectedId: selectedId, })

        }).finally(() => {
            // setLinearLoading(false)
            this.setState({ isLoading: false })
        })
    }

    // 更新一级菜单
    public onSave = async () => {
        const { selectedId } = this.state
        const api1 = await apiManage_rbp.patchSettingById(1, { init: true, menu_id: selectedId })
        if (!_.get(api1, 'error')) {
            GlobalNotification.success(i18n.t('global_text_operate_success'))
            this.setState({ oldSelectedId: selectedId })
            this.props.afterOnSave()
        } else {
            GlobalNotification.error(i18n.t('global_text_operate_failure'))
        }
    }

    // *********************
    // View
    // *********************
    render() {
        const { selectedId, menus, oldSelectedId, isLoading } = this.state;
        const newMenus = menus.map(menuItem => {
            return ({
                main_group_id: menuItem.main_group_id,
                main_group_name: menuItem.main_group_name
            })
        })
        return (
            <Card
                className='extra-cost-first-menu'
                title={(
                    <Box display='flex' alignItems='center'>
                        <Typography variant='h6'>{i18n.t('rwa_setting_page_first_menu')}</Typography>
                    </Box>
                )}
                actionRender={(
                    <ButtonComponent
                        action='SAVE'
                        disabled={selectedId === undefined || selectedId === oldSelectedId}
                        handleClick={this.onSave}
                    />
                )}
                contentRender={(
                    <>
                        {isLoading ?
                            <Skeleton height={200} /> :
                            <Grid container spacing={3}>
                                {
                                    newMenus.map((item) => (
                                        <Grid item xs={12} sm={2} key={item.main_group_id}>
                                            <Button
                                                className='select-btn'
                                                variant={item.main_group_id === selectedId ? 'contained' : 'outlined'}
                                                onClick={(event) => {
                                                    event.stopPropagation();
                                                    this.setState({ selectedId: item.main_group_id })
                                                }}
                                            >
                                                {item.main_group_name}
                                            </Button>
                                        </Grid>
                                    ))
                                }
                            </Grid>}
                    </>
                )}
            />
        )
    }
}

export default ExtraCostFirstMenuSetting;


// *********************
// Type
// *********************
type Props = {
    afterOnSave: Function;
}

type State = {
    // 菜单列表
    menus: Array<FirstMenu>;
    // 选中的菜单id
    selectedId: number | undefined;
    // setting 的id
    oldSelectedId: number | undefined;
    // 加载中
    isLoading: boolean;
}